import React from 'react'
import { Grid, Theme, Typography } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { Modifications as ModificationsType } from '@src/types/graphql-types'
import FeasibilityMessage from './FeasibilityMessage'
import BaseModificationSingle from './BaseModificationSingle'
import { InsertModificationArgs } from '../../ProductsConfiguration'

interface InternalModificationsForLongOligosProps {
  disabled: boolean
  degenerateBasesData?: ModificationsType
  insertModificationIntoSequence: ({
    value,
    resetMod,
    isAntiSense,
  }: InsertModificationArgs) => Promise<string>
}
const useStyle = makeStyles((theme: Theme) => {
  return {
    baseCategoryTitle: {
      fontSize: theme.typography.pxToRem(16),
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 700,
    },
    infoText: {
      fontSize: theme.typography.pxToRem(14),
    },
  }
})
const InternalModificationsForLongOligos: React.FC<
  InternalModificationsForLongOligosProps
> = ({ disabled, degenerateBasesData, insertModificationIntoSequence }) => {
  const classes = useStyle()
  const intl = useIntl()

  return (
    <>
      <Grid container style={{ marginTop: '24px' }}>
        <Grid item xs={12} className={classes.title}>
          <FormattedMessage
            id="INTERNAL_MODIFICATIONS"
            defaultMessage="Internal Modifications"
          />
        </Grid>
      </Grid>
      <Grid container>
        <Typography
          component="span"
          variant="body1"
          data-scrub
          className={classes.infoText}
        >
          <FormattedMessage
            id="INTERNAL_MODIFICATIONS_FOR_LONG_OLIGOS_MESSAGE"
            defaultMessage="Insert your cursor at the desired position within the sequence field above and click the ‘Add’ link below."
          />
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: '16px' }} spacing={10}>
        <Grid item sm={12}>
          {degenerateBasesData?.category
            .sort(
              (a, b) =>
                (a.order ? parseInt(a.order) : 0) -
                (b.order ? parseInt(b.order) : 0)
            )
            .map((category) => (
              <Grid item xs={3} key={category.categoryName}>
                <Typography
                  component="span"
                  variant="h3"
                  data-scrub
                  className={classes.baseCategoryTitle}
                >
                  {category.categoryDisplayName
                    ? intl.formatMessage({
                        id: category.categoryDisplayName,
                        defaultMessage: category.categoryName,
                      })
                    : category.categoryName}
                </Typography>
                {category.modifications.map((single) => (
                  <BaseModificationSingle
                    key={single.name}
                    disabled={disabled}
                    degenerateBase={single}
                    insertModificationIntoSequence={
                      insertModificationIntoSequence
                    }
                  />
                ))}
              </Grid>
            ))}
        </Grid>
      </Grid>
      <FeasibilityMessage />
    </>
  )
}

export default InternalModificationsForLongOligos
